import { Controller } from "@hotwired/stimulus"

// Blocks modal close while a treatment form is open in #selected-form-content.
// Span treatments keep their form visible after save, so they are not treated as pending.
export default class extends Controller {
  static values = {
    message: { type: String, default: "Tenés un tratamiento pendiente de guardar antes de confirmar y cerrar" }
  }

  guard(event) {
    const scope = this.element.closest("#odontogram-form-modal") || this.element
    const pendingForm = scope.querySelector("#selected-form-content form")
    if (!pendingForm || this.isSpanTreatmentForm(pendingForm)) return

    event.preventDefault()
    alert(this.messageValue)
  }

  isSpanTreatmentForm(form) {
    return form.action.includes("span_treatments")
  }
}
